module.exports = __webpack_public_path__ + "img/format_color_text.ac239870.svg";